import React, { useEffect, useState } from "react";
import MenuBar from "../common/MenuPanel";
import FooterPanel from "../common/FooterPanel";
import LoginForm from "./LoginForm";
import { useLocation } from "react-router-dom";
import userGuide from "../../attachments/GA_User_Guide.pdf";

const LoginPage = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const idMenuQuery = queryParams.get("id");

  const [showInstructions, setShowInstructions] = useState(false); // State to toggle visibility of instructions

  useEffect(() => {
    console.log("\n\n****************");
     console.log("LOGIN PAGE useEffect idMenuQuery:", idMenuQuery);
  }, [idMenuQuery]);

  return (
    <React.Fragment>
      <div className="container-fluid position-relative p-0">
        <MenuBar />
      </div>

      {/* Title Section with Overlay */}
      <div className="container-fluid p-0">
        <div
          className="banner-image_sm"
          style={{
            backgroundImage: `url(${process.env.PUBLIC_URL}/images/2.png)`,
          }}
        >
          <div className="banner-heading text-center wow fadeInDown">
            <h1 className="text-white">
              {idMenuQuery ? "Retreat Registration" : "Login"}
            </h1>
          </div>
        </div>
      </div>

      <div className="container mt-2 mb-0">
        <div className="banner-description text-glow mb-2">
          <i>
            So then you are no longer strangers and sojourners, but you are
            fellow citizens with the holy ones and members of the household of
            God, built upon the foundation of the apostles and prophets, with
            Christ Jesus himself as the capstone. Through him the whole
            structure is held together and grows into a temple sacred in the
            Lord; in him you also are being built together into a dwelling place
            of God in the Spirit.
          </i>{" "}
          - Ephesians 2:19-22{" "}
        </div>

        {idMenuQuery && (
          <div className="alert alert-info position-relative top-0 mt-0.5 mb-0.5">
            
            <span>
              Please follow the steps below to complete your retreat
              registration: 👉
            </span>

            {/* Button to toggle instructions visibility */}
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setShowInstructions(!showInstructions);
              }}
              className="btn-outline-primary text-decoration-underline position-absolute end-0 me-3"
            >
              {showInstructions
                ? " Hide Instructions ▲ "
                : " Show Instructions ▼ "}
            </a>
            {/* Display instructions only if showInstructions is true */}
            {showInstructions && (
              <>
                <div className="mt-0.5 mb-0">
                  <strong>Option 1: With Sign Up</strong> {"->"} Click{" "}
                  <b>"Sign Up"</b>
                  <ol className="mt-0.5 mb-0">
                    <li>
                      Fill out the Sign Up form and <b>"Submit"</b>.
                    </li>
                    <li>
                      After a successful sign-up, the Retreat Registration page
                      will open.
                    </li>
                    <li>
                      Enter the emergency contact name, phone number, and
                      payment method.
                    </li>
                    <li>
                      Click <b>"Next"</b> and Enter the participant details for
                      all participants.
                    </li>
                    <li>
                      Click <b>"Save"</b> and receive a confirmation email.
                    </li>
                  </ol>
                  <strong>Option 2: Continue as Guest</strong> {"->"} Click{" "}
                  <b>"Continue as Guest"</b>
                  <ol className="mt-0.5 mb-1">
                    <li>
                      The Retreat Registration page with Section for verifying
                      the phone number option will appear.
                    </li>
                    <li>
                   
                      Enter your email and phone number, then click{" "}
                      <b>"Send OTP"</b>.
                    </li>
                    <li>
                      Enter the OTP received on your phone and click{" "}
                      <b>"Verify OTP"</b>.
                    </li>
                    <li>
                      Enter the address details, emergency contact name, phone
                      number, and payment method.
                    </li>
                    <li>
                      Click {" "}<b>"Next"</b> and Enter the participant details for
                      all participants.
                    </li>
                    <li>
                      Click <b>"Save"</b> and receive a confirmation email.
                    </li>
                  </ol>
                  For detailed steps, refer to the{" "}
                  <a href={userGuide} target="_blank" rel="noopener noreferrer">
                    User Guide Document
                  </a>
                  .{" "}
                </div>
              </>
            )}
          </div>
        )}

        <LoginForm redirectID={idMenuQuery} />
      </div>
      <FooterPanel />
    </React.Fragment>
  );
};

export default LoginPage;
